export const inverterTelemetryMock = {
  readAtLocal: '2026-05-06 14:30:00',
  coverage: 'full',
  qualityFlag: 'ok',
  // Root-level fields (new API contract)
  totalPacKw: 524.8,
  totalPacKwWithoutUnit6: 482.5,
  unit6PacKw: 42.3,
  totalPpvKw: 540.5,
  percentOfNominal: 52.5,
  availableInverterCount: 8,
  expectedInverterCount: 8,
  nominal: {
    inverterKw: 125,
    plantKw: 1000,
  },
  // Legacy totals (fallback)
  totals: {
    totalPacKw: 524.8,
    totalPpvKw: 540.5,
    percentOfNominal: 52.5,
  },
  forecast: {
    forecastCurrentKw: 510.0,
    forecastForLocal: '2026-05-06 14:30:00',
  },
  comparison: {
    deltaKw: 14.8,
    deltaPct: 2.9,
  },
  inverters: [
    {
      unitId: 1,
      title: 'Unit 1',
      pacKw: 58.2,
      ppvKw: 60.1,
      phaseSumKw: 58.2,
      percentOfNominal: 46.6,
      statusRaw: 'generating',
      qualityFlag: 'ok',
      operationalState: 'generating',
      experimental: false,
      includedInPlantTotal: true,
      attempts: 1,
      errorMessage: null,
    },
    {
      unitId: 2,
      title: 'Unit 2',
      pacKw: 62.4,
      ppvKw: 64.8,
      phaseSumKw: 62.4,
      percentOfNominal: 49.9,
      statusRaw: 'generating',
      qualityFlag: 'ok',
      operationalState: 'generating',
      experimental: false,
      includedInPlantTotal: true,
      attempts: 1,
      errorMessage: null,
    },
    {
      unitId: 3,
      title: 'Unit 3',
      pacKw: 55.8,
      ppvKw: 58.0,
      phaseSumKw: 55.8,
      percentOfNominal: 44.6,
      statusRaw: 'generating',
      qualityFlag: 'ok',
      operationalState: 'generating',
      experimental: false,
      includedInPlantTotal: true,
      attempts: 1,
      errorMessage: null,
    },
    {
      unitId: 4,
      title: 'Unit 4',
      pacKw: 60.1,
      ppvKw: 62.5,
      phaseSumKw: 60.1,
      percentOfNominal: 48.1,
      statusRaw: 'generating',
      qualityFlag: 'ok',
      operationalState: 'generating',
      experimental: false,
      includedInPlantTotal: true,
      attempts: 1,
      errorMessage: null,
    },
    {
      unitId: 5,
      title: 'Unit 5',
      pacKw: 59.7,
      ppvKw: 61.8,
      phaseSumKw: 59.7,
      percentOfNominal: 47.8,
      statusRaw: 'generating',
      qualityFlag: 'ok',
      operationalState: 'generating',
      experimental: false,
      includedInPlantTotal: true,
      attempts: 1,
      errorMessage: null,
    },
    {
      unitId: 6,
      title: 'Unit 6',
      pacKw: 42.3,
      ppvKw: 45.0,
      phaseSumKw: 42.3,
      percentOfNominal: 33.8,
      statusRaw: 'generating',
      qualityFlag: 'ok',
      operationalState: 'generating',
      experimental: false,
      includedInPlantTotal: true,
      attempts: 1,
      errorMessage: null,
    },
    {
      unitId: 7,
      title: 'Unit 7',
      pacKw: 63.2,
      ppvKw: 65.5,
      phaseSumKw: 63.2,
      percentOfNominal: 50.6,
      statusRaw: 'generating',
      qualityFlag: 'ok',
      operationalState: 'generating',
      experimental: false,
      includedInPlantTotal: true,
      attempts: 1,
      errorMessage: null,
    },
    {
      unitId: 8,
      title: 'Unit 8',
      pacKw: 58.9,
      ppvKw: 61.0,
      phaseSumKw: 58.9,
      percentOfNominal: 47.1,
      statusRaw: 'generating',
      qualityFlag: 'ok',
      operationalState: 'generating',
      experimental: false,
      includedInPlantTotal: true,
      attempts: 1,
      errorMessage: null,
    },
  ],
};

export const inverterTelemetryMockWithErrors = {
  readAtLocal: '2026-05-06 14:30:00',
  coverage: 'partial',
  qualityFlag: 'read_error',
  // Root-level fields
  totalPacKw: 428.4,
  totalPacKwWithoutUnit6: 386.1,
  unit6PacKw: 42.3,
  totalPpvKw: null,
  percentOfNominal: 42.8,
  availableInverterCount: 6,
  expectedInverterCount: 8,
  nominal: {
    inverterKw: 125,
    plantKw: 1000,
  },
  // Legacy totals
  totals: {
    totalPacKw: 428.4,
    totalPpvKw: null,
    percentOfNominal: 42.8,
  },
  forecast: {
    forecastCurrentKw: null,
    forecastForLocal: '2026-05-06 14:30:00',
  },
  comparison: {
    deltaKw: null,
    deltaPct: null,
  },
  inverters: [
    {
      unitId: 1,
      title: 'Unit 1',
      pacKw: null,
      ppvKw: null,
      phaseSumKw: null,
      percentOfNominal: null,
      statusRaw: 'no_data',
      qualityFlag: 'no_data',
      operationalState: 'normal_no_power',
      experimental: false,
      includedInPlantTotal: true,
      attempts: 3,
      errorMessage: 'No response from inverter Modbus address 1',
    },
    {
      unitId: 2,
      title: 'Unit 2',
      pacKw: 62.4,
      ppvKw: 64.8,
      phaseSumKw: 62.4,
      percentOfNominal: 49.9,
      statusRaw: 'generating',
      qualityFlag: 'ok',
      operationalState: 'generating',
      experimental: false,
      includedInPlantTotal: true,
      attempts: 1,
      errorMessage: null,
    },
    {
      unitId: 3,
      title: 'Unit 3',
      pacKw: null,
      ppvKw: null,
      phaseSumKw: null,
      percentOfNominal: null,
      statusRaw: 'read_error',
      qualityFlag: 'read_error',
      operationalState: 'standby_or_waiting',
      experimental: false,
      includedInPlantTotal: true,
      attempts: 3,
      errorMessage: 'Modbus CRC error on registers 30775-30776',
    },
    {
      unitId: 4,
      title: 'Unit 4',
      pacKw: 60.1,
      ppvKw: 62.5,
      phaseSumKw: 60.1,
      percentOfNominal: 48.1,
      statusRaw: 'generating',
      qualityFlag: 'ok',
      operationalState: 'generating',
      experimental: false,
      includedInPlantTotal: true,
      attempts: 1,
      errorMessage: null,
    },
    {
      unitId: 5,
      title: 'Unit 5',
      pacKw: 59.7,
      ppvKw: 61.8,
      phaseSumKw: 59.7,
      percentOfNominal: 47.8,
      statusRaw: 'generating',
      qualityFlag: 'ok',
      operationalState: 'generating',
      experimental: false,
      includedInPlantTotal: true,
      attempts: 1,
      errorMessage: null,
    },
    {
      unitId: 6,
      title: 'Unit 6',
      pacKw: 42.3,
      ppvKw: 45.0,
      phaseSumKw: 42.3,
      percentOfNominal: 33.8,
      statusRaw: 'generating',
      qualityFlag: 'ok',
      operationalState: 'generating',
      experimental: false,
      includedInPlantTotal: true,
      attempts: 1,
      errorMessage: null,
    },
    {
      unitId: 7,
      title: 'Unit 7',
      pacKw: 63.2,
      ppvKw: 65.5,
      phaseSumKw: 63.2,
      percentOfNominal: 50.6,
      statusRaw: 'generating',
      qualityFlag: 'ok',
      operationalState: 'generating',
      experimental: false,
      includedInPlantTotal: true,
      attempts: 1,
      errorMessage: null,
    },
    {
      unitId: 8,
      title: 'Unit 8',
      pacKw: 58.9,
      ppvKw: 61.0,
      phaseSumKw: 58.9,
      percentOfNominal: 47.1,
      statusRaw: 'generating',
      qualityFlag: 'ok',
      operationalState: 'generating',
      experimental: false,
      includedInPlantTotal: true,
      attempts: 1,
      errorMessage: null,
    },
  ],
};